// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".self-defined-classname[data-v-8eac15e8] {\n  width: 100%;\n  height: 300px;\n  margin-bottom: 24px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
